import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import VideoCard from "@/components/feature/VideoCard";
import { categories, featuredVideos, videos } from "@/mocks/videos";

export default function Home() {
  const latestVideos = [...videos]
    .sort(() => Math.random() - 0.5)
    .slice(0, 8);

  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "神马视频",
    url: "https://www.shenmavideo.com",
    description: "神马视频提供91视频、91在线视频、97视频、51视频高清影视大全，免费在线观看，不缓冲流畅播放，电视剧电影一应俱全。",
    sameAs: [
      "https://www.shenmavideo.com",
    ],
  };

  const webSiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "神马视频",
    url: "https://www.shenmavideo.com",
    description: "神马视频提供91视频、91在线视频、97视频、51视频高清影视大全，免费在线观看，不缓冲流畅播放，电视剧电影一应俱全。",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://www.shenmavideo.com/search?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  };

  const webPageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "神马视频 - 91视频、91在线视频免费在线观看全集 | 97视频51视频高清影视大全",
    description: "神马视频提供91视频、91在线视频等数字系列视频网站免费在线观看，97视频、51视频高清影视大全，不缓冲流畅播放，电视剧电影一应俱全。",
    url: "https://www.shenmavideo.com",
    isPartOf: {
      "@type": "WebSite",
      name: "神马视频",
      url: "https://www.shenmavideo.com",
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webSiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <header>
          <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=A%20cinematic%20wide%20composition%20featuring%20a%20dark%20theater%20stage%20with%20deep%20red%20velvet%20curtains%20drawn%20open%20revealing%20a%20glowing%20screen%2C%20warm%20golden%20spotlights%20creating%20dramatic%20beams%2C%20rich%20amber%20and%20burgundy%20tones%2C%20elegant%20theater%20atmosphere%20with%20subtle%20dust%20particles%20in%20light%20beams%2C%20premium%20cinematic%20aesthetic%2C%20no%20text%20visible%2C%20abstract%20theatrical%20mood&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
              alt="神马视频 - 高清影视大全"
              title="神马视频 - 91视频、91在线视频、97视频、51视频高清影视大全"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
            <div className="relative z-10 w-full text-center px-4">
              <h1 className="text-3xl md:text-5xl font-bold text-white mb-3 md:mb-4 font-heading">
                神马视频
              </h1>
              <p className="text-sm md:text-lg text-white/80 max-w-2xl mx-auto leading-relaxed">
                91视频、91在线视频、97视频、51视频高清影视大全，免费在线观看，不缓冲流畅播放，电视剧电影一应俱全
              </p>
              <div className="mt-6 md:mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
                <Link
                  to="/category/dianshiju"
                  className="px-6 py-3 bg-primary-500 text-background-50 rounded-md text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  立即观看
                </Link>
                <Link
                  to="/category/dianying"
                  className="px-6 py-3 bg-white/10 text-white border border-white/30 rounded-md text-sm font-medium hover:bg-white/20 transition-colors whitespace-nowrap cursor-pointer"
                >
                  热门电影
                </Link>
              </div>
            </div>
          </section>
        </header>

        <main>
          <section className="w-full px-4 md:px-6 py-10 md:py-14">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-8">
                <h2 className="text-xl md:text-3xl font-bold text-foreground-950 font-heading">
                  视频分类
                </h2>
                <p className="mt-2 text-sm text-foreground-500">
                  选择你感兴趣的分类，发现更多精彩内容
                </p>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="flex flex-col items-center gap-2 p-4 md:p-5 bg-background-50 rounded-lg border border-background-200 hover:border-primary-200 hover:shadow-sm transition-all duration-300 cursor-pointer group"
                  >
                    <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                      <i className={`${cat.icon} text-xl md:text-2xl`}></i>
                    </div>
                    <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                      {cat.name}
                    </span>
                  </Link>
                ))}
              </div>
            </div>
          </section>

          <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center justify-between mb-8">
                <div>
                  <h2 className="text-xl md:text-3xl font-bold text-foreground-950 font-heading">
                    热门推荐
                  </h2>
                  <p className="mt-2 text-sm text-foreground-500">
                    精选高分影视，大家都在看
                  </p>
                </div>
                <Link
                  to="/category/dianshiju"
                  className="text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap font-medium"
                >
                  查看全部 <i className="ri-arrow-right-line ml-1"></i>
                </Link>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
                {featuredVideos.slice(0, 8).map((video) => (
                  <VideoCard
                    key={video.id}
                    slug={video.slug}
                    title={video.title}
                    categoryName={video.categoryName}
                    description={video.description}
                    coverImage={video.coverImage}
                    rating={video.rating}
                    views={video.views}
                    updateStatus={video.updateStatus}
                    episodeCount={video.episodeCount}
                  />
                ))}
              </div>
            </div>
          </section>

          <section className="w-full px-4 md:px-6 py-10 md:py-14">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center justify-between mb-8">
                <div>
                  <h2 className="text-xl md:text-3xl font-bold text-foreground-950 font-heading">
                    最新更新
                  </h2>
                  <p className="mt-2 text-sm text-foreground-500">
                    每日更新，精彩不容错过
                  </p>
                </div>
                <Link
                  to="/category/zongyi"
                  className="text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap font-medium"
                >
                  更多内容 <i className="ri-arrow-right-line ml-1"></i>
                </Link>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
                {latestVideos.map((video) => (
                  <VideoCard
                    key={video.id}
                    slug={video.slug}
                    title={video.title}
                    categoryName={video.categoryName}
                    description={video.description}
                    coverImage={video.coverImage}
                    rating={video.rating}
                    views={video.views}
                    updateStatus={video.updateStatus}
                    episodeCount={video.episodeCount}
                  />
                ))}
              </div>
            </div>
          </section>

          <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-8">
                <h2 className="text-xl md:text-3xl font-bold text-foreground-950 font-heading">
                  为什么选择神马视频
                </h2>
                <p className="mt-2 text-sm text-foreground-500">
                  我们致力于为用户提供最优质的在线观影体验
                </p>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
                <div className="p-5 md:p-6 bg-background-50 rounded-lg border border-background-200 text-center">
                  <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                    <i className="ri-flashlight-line text-xl"></i>
                  </div>
                  <h3 className="mt-4 text-base font-semibold text-foreground-900 font-heading">
                    极速播放不缓冲
                  </h3>
                  <p className="mt-2 text-sm text-foreground-500 leading-relaxed">
                    采用先进的CDN加速技术，确保视频流畅播放，告别卡顿和缓冲等待。
                  </p>
                </div>
                <div className="p-5 md:p-6 bg-background-50 rounded-lg border border-background-200 text-center">
                  <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                    <i className="ri-hd-line text-xl"></i>
                  </div>
                  <h3 className="mt-4 text-base font-semibold text-foreground-900 font-heading">
                    高清画质体验
                  </h3>
                  <p className="mt-2 text-sm text-foreground-500 leading-relaxed">
                    支持1080P超高清画质，91视频、97视频、51视频全部高清呈现，视觉享受不打折。
                  </p>
                </div>
                <div className="p-5 md:p-6 bg-background-50 rounded-lg border border-background-200 text-center">
                  <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                    <i className="ri-global-line text-xl"></i>
                  </div>
                  <h3 className="mt-4 text-base font-semibold text-foreground-900 font-heading">
                    海量资源全覆盖
                  </h3>
                  <p className="mt-2 text-sm text-foreground-500 leading-relaxed">
                    涵盖电视剧、电影、综艺、动漫、纪录片等全品类，91在线视频一网打尽。
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="w-full px-4 md:px-6 py-10 md:py-14">
            <div className="max-w-7xl mx-auto text-center">
              <h2 className="text-xl md:text-3xl font-bold text-foreground-950 font-heading">
                开启你的观影之旅
              </h2>
              <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
                神马视频汇聚全网优质影视资源，高清不缓冲，随时随地畅享精彩内容
              </p>
              <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-3">
                <Link
                  to="/category/dianshiju"
                  className="px-6 py-3 bg-accent-500 text-background-50 rounded-md text-sm font-medium hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  浏览电视剧
                </Link>
                <Link
                  to="/about"
                  className="px-6 py-3 bg-background-50 text-foreground-700 border border-background-200 rounded-md text-sm font-medium hover:border-primary-200 transition-colors whitespace-nowrap cursor-pointer"
                >
                  了解更多
                </Link>
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}